import { render } from "./PageHeader.vue?vue&type=template&id=ed5906ea&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=ed5906ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed5906ea"

export default script